// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Attachments_wrapper__1czCB","group":"Attachments_group__2rp9j"};